// @ts-strict-ignore
import { useState } from 'react'

import { Button } from '@/shared/ui'

import cl from './CheckBox.module.scss'

const CheckBox = ({ items, changeHandler, initialState = 'online' }) => {
	const [activeShop, setActiveShop] = useState(initialState)
	const handleClick = e => {
		const { value } = e.target
		setActiveShop(value)
		changeHandler(value)
	}
	return (
		<div className={cl.checkbox__wrapper}>
			{items.map(item => {
				if (activeShop === item.value) {
					return (
						<Button value={item.value} key={item.value} onClick={handleClick}>
							{item.title}
						</Button>
					)
				}
				return (
					<Button value={item.value} key={item.value} className={cl.btn_disabled} onClick={handleClick}>
						{item.title}
					</Button>
				)
			})}
		</div>
	)
}

export default CheckBox
